import React from 'react';
import mixpanel from 'mixpanel-browser';
import CodeSparkThemedTypography from '../../../../components/elements/CodeSparkThemedTypography';
import CtaButton from '../../../../components/elements/CtaButton';
import TextLink from '../../../../components/elements/TextLink';
import CtaButtonContainer from '../../../../components/elements/CtaButton/CtaButtonContainer';
import {
  SectionPaddingSideRedesign,
  SectionPaddingVertical,
} from '../../../../components/global/Layout';
import {
  MRKT_ATTR__MP_DISTINCT_ID,
  MRKT_ATTR__REF_PAGE,
  MRKT_ATTR__SITE_NAME,
  MRKT_ATTR__UTM_CAMPAIGN,
  MRKT_ATTR__UTM__SOURCE,
} from '../../../../constants/marketing';
import { getBeginPromotionalVariantData } from './beginPromotionalData';

import styles from './BeginPromotional.module.css';
import { queryParamsToString } from '../../../../utils/stringUtils';

function BeginPromotional({
  onCtaClick,
  image,
  imageAlt,
  imageSubtitle,
  body,
  cta,
  learnMore,
  title,
  componentName,
}) {
  const handleCtaClick = e => onCtaClick(e, componentName);

  const linkQueryString = queryParamsToString({
    [MRKT_ATTR__UTM__SOURCE]: MRKT_ATTR__SITE_NAME,
    [MRKT_ATTR__MP_DISTINCT_ID]: mixpanel.get_distinct_id(),
    [MRKT_ATTR__UTM_CAMPAIGN]: componentName,
    [MRKT_ATTR__REF_PAGE]: '/',
  });

  return (
    <SectionPaddingSideRedesign className={styles.beginPromotionalSection}>
      <SectionPaddingVertical>
        <div className="grid-x align-middle grid-margin-x">
          <div className={`cell small-12 large-5 ${styles.leftWrapper}`}>
            <div>
              <img src={image} alt={imageAlt} />
            </div>

            <CodeSparkThemedTypography variant="finePrint" className={styles.imageSubtitle}>
              {imageSubtitle}
            </CodeSparkThemedTypography>
          </div>
          <div className={`cell small-12 large-7 ${styles.rightWrapper}`}>
            <CodeSparkThemedTypography variant="h2">{title}</CodeSparkThemedTypography>
            <CodeSparkThemedTypography variant="body1" className={styles.body}>
              {body}
            </CodeSparkThemedTypography>

            <CtaButtonContainer align="center" className={styles.ctaButtonContainer}>
              <CtaButton className={styles.ctaButton} onClick={handleCtaClick}>
                {cta.ctaLabel}
              </CtaButton>
            </CtaButtonContainer>

            <div className={styles.learnMoreLinkContainer}>
              <TextLink href={`${learnMore.link}${linkQueryString}`} target="_blank">
                {learnMore.linkText}
              </TextLink>
            </div>
          </div>
        </div>
      </SectionPaddingVertical>
    </SectionPaddingSideRedesign>
  );
}

export default function BeginPromotionalWrapper(props) {
  const data = getBeginPromotionalVariantData();

  return <BeginPromotional {...props} {...data} />;
}



// WEBPACK FOOTER //
// ./src/containers/Home/sections/BeginPromotional/index.js